import { Box, useMediaQuery, useTheme } from "@mui/material";

import BTPLogoImg from "../../assets/img/btp_logo.svg";
import ColpLogoImg from "../../assets/img/colp_logo.svg";
import ThalamosLogoImg from "../../assets/img/logo.svg";
import MetLogoImg from "../../assets/img/met_logo.svg";
import MHFormsLogoWitghBgImg from "../../assets/img/mh_forms_grey_bg_logo.svg";
import MHFormsLogoImg from "../../assets/img/mh_forms_logo.svg";

type ForceLogoProps = {
  src: string;
  alt: string;
};

const ForceLogo = ({ src, alt }: ForceLogoProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: isDesktop ? "4rem" : "3rem",
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
        }}
      />
    </Box>
  );
};

export const BTPLogo = () => <ForceLogo src={BTPLogoImg} alt="BTP Logo" />;
export const MetLogo = () => (
  <ForceLogo src={MetLogoImg} alt="Metropolitan Police Logo" />
);
export const ColpLogo = () => (
  <ForceLogo src={ColpLogoImg} alt="City of London Police Logo" />
);

export const MHFormsLogo = () => (
  <Box
    sx={{
      display: "flex",
      height: "100%",
      paddingLeft: "3rem",
    }}
  >
    <img src={MHFormsLogoImg} alt="MH Forms Logo" />
  </Box>
);

export const ThalamosLogo = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <img
      src={ThalamosLogoImg}
      alt="Thalamos Logo"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        width: "auto",
        height: "auto",
      }}
    />
  </Box>
);

export const MHFormsLogoWithBackground = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <img src={MHFormsLogoWitghBgImg} alt="MH Forms Logo" />
    </Box>
  );
};
